/* eslint-disable max-lines */
/* eslint-disable complexity */
import _ from 'lodash';
import commonFunctions from '../common-functions';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import VueSlider from 'vue-slider-component';

export default {
    name: 'ConciliationTransfers',

    extends: commonFunctions,

    components: {
        DateRangePicker,
        VueSlider
    },

    props: {
        data: {
            type: Array,
            required: true
        },
        checks: {
            type: Boolean,
            required: false,
            default: true
        },
        icons: {
            type: Boolean,
            required: false,
            default: true
        },
        actions: {
            type: Boolean,
            required: false,
            default: false
        },
        details: {
            type: Boolean,
            required: false,
            default: true
        },
        filter: {
            type: Boolean | String,
            required: false,
            default: 'all'
        },
        sortable: {
            type: Boolean,
            required: false,
            default: false
        },
        editable: {
            type: Boolean,
            required: false,
            default: false
        },
        monitorType: {
            type: String,
            required: false,
            default: 'all'
        },
        sortBy: {
            type: String,
            required: false,
            default: 'transaction_date'
        },
        sortDesc: {
            type: Boolean,
            required: false,
            default: true
        },
        scrollTop: {
            type: Number,
            required: false,
            default: 50
        },
        settedFilters: {
            type: Object,
            required: false,
            default: () => ({})
        },
        maxAmount: {
            type: Number,
            required: false,
            default: 1000000
        },
        minAmount: {
            type: Number,
            required: false,
            default: 0
        }
    },

    /**
     * @override
     */
    data() {
        return {
            updateKey: 0,
            savingNote: false,
            fields: [
                {
                    key: 'show_checks',
                    label: '',
                    thClass: this.checks ? '' : 'd-none',
                    tdClass: this.checks ? 'px-0 text-center' : 'd-none'
                },
                {
                    key: 'show_icons',
                    label: '',
                    thClass: this.icons ? '' : 'd-none',
                    tdClass: this.icons ? 'px-0 text-center d-flex align-items-center pt-3' : 'd-none'
                },
                {
                    key: 'transaction_date',
                    label: 'Fecha valor',
                    thClass: 'fecha_tr',
                    sortable: this.sortable,
                    formatter: value => {
                        return this.$moment(new Date(value)).format('DD-MMM-YYYY');
                    }
                },
                {
                    key: 'key_product',
                    label: 'Producto',
                    sortable: this.sortable,
                    formatter: value => {
                        return this.$t(`operations.products.${value}`);
                    }
                },
                {
                    key: 'concept',
                    label: 'Concepto',
                    tdClass: 'concept-td',
                    sortable: this.sortable
                },
                {
                    key: 'gross_amount',
                    label: 'Cantidad',
                    thClass: 'text-right',
                    tdClass: 'text-right color-brand',
                    sortable: this.sortable,
                    formatter: value => {
                        return value ? `${this.$options.filters.yuriDecimals(value, 2)} €` : 'N/C';
                    }
                },
                {
                    key: 'details',
                    label: '',
                    thClass: this.details ? '' : 'd-none',
                    tdClass: this.details ? '' : 'd-none'
                },
                {
                    key: 'actions',
                    label: '',
                    thClass: this.actions ? '' : 'd-none',
                    tdClass: this.actions ? '' : 'd-none'
                }
            ],
            filters: {
                transaction_date: this.settedFilters.transaction_date || {
                    startDate: null,
                    endDate: null
                },
                key_product: this.settedFilters.key_product || '',
                concept: this.settedFilters.concept || '',
                gross_amount: this.settedFilters.gross_amount || false
            },
            filtering: false,
            loadingMore: false,
            timeOutFilter: null,
            timeOutFilterTime: 1500,
            localeDateRange: {
                direction: 'ltr',
                format: 'dd/mm/yyyy',
                separator: ' - ',
                daysOfWeek: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
                monthNames: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                firstDay: 1
            },
            rangeOpened: false,
            datepickerEndDate: ''
        };
    },

    watch: {
        datepickerEndDate(val) {
            this.filters['transaction_date'].startDate = val[0];
            this.filters['transaction_date'].endDate = val[1];
            this.changeColumnFilter('transaction_date');
        }
    },

    methods: {
        emitTransferToResume(item) {
            const { reconciliation } = item;
            const { isChecked } = this.$refs[`checkbox__${item.uuid}`];
            const searchBy = this.$store.getters['conciliationStore/searchBy'];

            if (reconciliation && (reconciliation.status === 'AGRUPADO' || reconciliation.status === 'PRECONCILIADO' || reconciliation.status === 'CONCILIADO')) {

                if (reconciliation.status === 'CONCILIADO') {
                    this.$store.dispatch('conciliationStore/disableAll', true);
                }

                this.$store.dispatch('conciliationStore/disableGroups', true);
                // Flag para controlar que se está editando un agrupado
                this.$store.dispatch('conciliationStore/setGroupedSelected', true);
                // Flag para guardar el UUID reconciliación
                this.$store.dispatch('conciliationStore/setUuidGroupedSelected', item.uuid_reconciliation);
                // Agrupado
                if (isChecked) {
                    // Deseleccionar todos los demás
                    this.$store.dispatch('conciliationStore/removeTransfersSelected');
                    this.$store.dispatch('conciliationStore/removeOperationsSelected');
                    this.$root.$emit('set_filtering_operations');
                    // Obtenemos los elementos agrupados de esa transferencia
                    this.$paymentsService
                        .getReconciliationInfo(item.uuid_reconciliation)
                        .then(res => {
                            this.$store.dispatch('conciliationStore/setComment', res.data.reconciliation.comment);
                            this.autoSelectElements(res.data.reconciliation);
                            if (this.monitorType === 'historic' || reconciliation.status === 'CONCILIADO') {
                                const { operations } = res.data.reconciliation;
                                operations.map(operation => {
                                    operation.reconciliation = {};
                                    operation.reconciliation.uuid = res.data.reconciliation.uuid;
                                    operation.reconciliation.comment = res.data.reconciliation.comment;
                                    operation.reconciliation.status = res.data.reconciliation.status;
                                    return operation;
                                });
                                this.$root.$emit('set_operations', operations);
                            } else if (!searchBy || searchBy === 'transactions') {
                                this.getSuggestions();
                            }
                        })
                        .catch(err => console.error(err));
                } else {
                    this.transferToStore(item, 'remove');
                    const transactionsList = this.$store.getters['conciliationStore/transfers'];
                    if (!transactionsList.length && searchBy === 'transfers') {
                        this.$root.$emit('filter_operations', 'all');
                        this.$store.dispatch('conciliationStore/setSuggestions', false);
                        this.$store.dispatch('conciliationStore/setSearchBy', false);
                    } else if (!searchBy || searchBy === 'transfers') {
                        this.getSuggestions();
                    }
                }
            } else {
                // No agrupado
                this.$store.dispatch('conciliationStore/disableGroups', true);

                this.transferToStore(item, isChecked ? 'add' : 'remove');

                if (isChecked) {
                    if (!searchBy || searchBy === 'transfers') {
                        this.getSuggestions();
                    }
                } else {
                    const transactionsList = this.$store.getters['conciliationStore/transfers'];
                    if (!transactionsList.length && searchBy === 'transfers') {
                        this.$store.dispatch('conciliationStore/disableGroups', false);
                        this.$store.dispatch('conciliationStore/disableAll', false);
                        this.$root.$emit('set_filtering_operations');
                        this.$root.$emit('filter_operations', 'all');
                        this.$store.dispatch('conciliationStore/setSuggestions', false);
                        this.$store.dispatch('conciliationStore/setSearchBy', false);
                    } else if (!searchBy || searchBy === 'transfers') {
                        this.getSuggestions();
                    }
                }
            }

            if (isChecked) {
                this.$root.$emit('height_resume', 80);
                if (!searchBy) {
                    this.$store.dispatch('conciliationStore/setSearchBy', 'transfers');
                }
            }
        },

        getSuggestions() {
            this.$store.dispatch('conciliationStore/setSuggestions', true);
            this.$root.$emit('set_filtering_operations');
            this.$root.$emit('get_operations_suggested');
        },

        isActive(item, type) {
            const index = _.findIndex(this.transfersSelected, item);
            if (type === 'row-details') {
                return 'bg-greybody';
            }
            if (!item || type !== 'row') {
                return false;
            }
            if (index >= 0) {
                return 'table-success';
            }
            return '';
        },

        isDisabled(item) {
            const disableChecks = this.$store.getters['conciliationStore/disableGroups'];
            const disableAll = this.$store.getters['conciliationStore/disableAll'];
            return (item.reconciliation && disableChecks) || disableAll ? true : false;
        },

        removeTransfer(item) {
            // Eliminar item de la store
            this.$store.dispatch('conciliationStore/removeTransfer', item);
            const operationsList = this.$store.getters['conciliationStore/operations'];
            const transactionsList = this.$store.getters['conciliationStore/transfers'];
            if (!transactionsList.length && !operationsList.length) {
                this.$store.dispatch('conciliationStore/setSuggestions', false);
                this.$store.dispatch('conciliationStore/setSearchBy', false);
                this.$root.$emit('set_filtering_operations');
                this.$root.$emit('set_filtering_transfers');
                this.clearSelection();
            }
        },

        changeFilter(filter) {
            this.filtering = true;
            // this.clearSelection(true);
            this.$root.$emit('filter_transactions', filter);
            // this.$root.$emit('filter_operations', filter);
            this.$store.dispatch('conciliationStore/setSuggestions', false);
        },

        changeColumnFilter(filter) {
            clearTimeout(this.timeOutFilter);
            let timeOutFilter = this.timeOutFilterTime;
            if (filter === 'request_date' || filter === 'gross_amount') {
                timeOutFilter = 0;
            }
            this.timeOutFilter = setTimeout(() => {
                this.filtering = true;
                this.$root.$emit('filter_columns_transactions', this.filters);
            }, timeOutFilter);
        },

        clearColumnFilter(filter) {
            if (filter === 'transaction_date') {
                this.filters[filter] = {
                    startDate: null,
                    endDate: null
                };
            } else {
                this.filters[filter] = false;
            }
            this.filtering = true;
            this.$root.$emit('filter_columns_transactions', this.filters);
        },

        sortingChanged(state) {
            this.filtering = true;
            this.$root.$emit('filter_transactions', false, state);
        },

        onScroll(event) {
            if (event.target.scrollTop + event.target.clientHeight >= event.target.scrollHeight - 20
                && this.data.metadata.paging._links._next.href
                && !this.loadingMore) {

                this.loadingMore = true;
                this.$root.$emit('more_transactions', this.data.metadata.paging._links._next.href, event.target.scrollTop);
            }
        },

        clearAll() {
            this.filtering = true;
        },

        toggleRange() {
            this.rangeOpened = !this.rangeOpened;
            if (!this.filters['gross_amount']) {
                this.filters['gross_amount'] = [this.minAmount, this.maxAmount];
            }
        },
        setFiltering() {
            this.filtering = true;
        },
        seeSuggestions() {
            this.$root.$emit('get_transfers_suggested');
        }

    },
    computed: {
        transfersAmmount() {
            let total = 0;
            this.data.forEach(item => {
                total += +item.gross_amount;
            });
            return total;
        },
        seleccionados: {
            get() {
                const items = this.$store.getters['conciliationStore/transfers'];
                const actives = items.map(x => x.uuid);
                return actives;
            },
            set(newName) {
                return newName;
            }
        },
        suggestions() {
            return this.$store.getters['conciliationStore/suggestions'];
        },
        searchBy() {
            return this.$store.getters['conciliationStore/searchBy'];
        }
    },
    mounted() {
        if (this.sortable) {
            this.$refs['transfers-table'].$el.addEventListener('scroll', this.onScroll);
            if (this.scrollTop) {
                this.$refs['transfers-table'].$el.scrollTop = this.scrollTop;
            }
        }
        this.$root.$on('get_transfers_suggested', this.setFiltering);
        this.$root.$on('set_filtering_transfers', this.setFiltering);
    },
    /**
     * @override
     */
    beforeDestroy() {
        this.$root.$off('get_transfers_suggested', this.setFiltering);
        this.$root.$off('set_filtering_transfers', this.setFiltering);
    }
};
